import { getThemeVariant } from '../theme/abTesting';
import { marketingContentA } from './variants/marketingContentA';
import marketingContentBJson from './variants/marketingContentB.json';

// Get marketing content based on A/B test variant
export const getMarketingContent = () => {
  const variant = getThemeVariant();
  
  if (variant === 'A') {
    return marketingContentA;
  }
  
  return marketingContentBJson;
};

// Export for i18n configuration
export const marketingContent = getMarketingContent();
